<template>
  <div class="standard-page v-flex">
    <b-button-toolbar
      class="button-toolbar"
      aria-label="Toolbar with button groups"
    >
      <b-button @click="createCustomer">
        <b-icon icon="person-fill" /> Create Customer
      </b-button>

      <b-form-file
        class="import-csv"
        v-model="file"
        placeholder="Choose a file or drop it here..."
        browse-text="Import CSV"
        @input="loadFile($event)"
      />
    </b-button-toolbar>

    <Table
      class="standard-page-table"
      :fields="tableHeaders"
      :items="customers"
      :busy="isBusy"
      :totalItems="totalCustomers"
      :totalPages="totalPages"
      :pageSize="pageSize"
      :currentPage="currentPage"
      @pageSizeChanged="handlePageSize"
      @pageChanged="handlePage"
    />
  </div>
</template>

<script>
import Table from '@/components/Table/Table.vue'
import endpoints from '@/utils/endpoints.js'
import tableMixins from '@/mixins/TableMixins/tableMixins.js'
import Papa from 'papaparse'

export default {
  mixins: [tableMixins],
  components: {
    Table
  },
  data() {
    return {
      tableHeaders: [
        {
          link: true,
          key: 'first_name',
          label: 'First Name'
        },
        'last_name',
        {
          key: 'sms_phone_number',
          label: 'Cell Phone'
        },
        'email'
      ],
      file: null,
      customers: [],
      isBusy: true,
      totalCustomers: null,
      pageSize: 10,
      currentPage: 1,
      totalPages: null
    }
  },
  mounted() {
    this.$store.dispatch('setPageTitle', { pageTitle: 'Customers' })
    this.getCustomers()
  },
  methods: {
    createCustomer() {
      this.$router.push({
        name: 'CustomerCreate'
      })
    },

    loadFile(file) {
      if (!file) return

      const config = {
        header: true,
        complete: this.onFileLoad,
        error: this.onFileError,
        skipEmptyLines: true
      }

      Papa.parse(file, config)
    },

    onFileLoad(results, file) {
      this.$store.commit('setCSVData', results)
      this.$router.push({
        name: 'CustomerImport'
      })
    },

    onFileError(err) {
      console.log(err)
    },

    getCustomers() {
      this.axios
        .get(endpoints.listCustomers(this.$route.params.merchantID), {
          params: { page: this.currentPage, page_size: this.pageSize }
        })
        .then(res => {
          this.customers = res.data.results
          this.isBusy = false
          this.totalCustomers = res.data.count
          this.totalPages = Math.ceil(this.totalCustomers / this.pageSize)
        })
        .catch(err => {
          console.log('error', err)
        })
    },
    handlePageSize(pageSize) {
      this.handlePageSizeChange(pageSize)
      this.getCustomers()
    },
    handlePage(newPage) {
      this.handlePageChange(newPage)
      this.getCustomers()
    }
  }
}
</script>

<style lang="scss" scoped>
.import-csv {
  margin-left: auto;
  max-width: 30%;
}
</style>
